module.exports = __webpack_public_path__ + "static/media/ctnfi.2c3d526e.png";